export default "__VITE_ASSET__7d5b9821__"